import { z } from 'zod';
/** API keys for third-party systems (AMS, GIS, smart-city platforms, sensor networks). */
export const ApiKeyPermission = z.enum([
    'device.view',
    'telemetry.view',
    'alarm.view',
    'report.view',
    'asset.view',
    'group.view',
    'project.view',
    'telemetry.ingest',
]);
export const ApiKey = z.object({
    id: z.uuid(),
    name: z.string(),
    token_prefix: z.string(),
    client_id: z.uuid().nullable(),
    client_name: z.string().nullable(),
    permissions: z.array(ApiKeyPermission),
    created_by: z.string().nullable(),
    created_at: z.string(),
    expires_at: z.string().nullable(),
    last_used_at: z.string().nullable(),
    revoked_at: z.string().nullable(),
    can_manage: z.boolean(),
});
export const ApiKeyList = z.object({ items: z.array(ApiKey) });
export const ApiKeyCreate = z.object({
    name: z.string().trim().min(1).max(120),
    client_id: z.uuid().nullable(),
    permissions: z.array(ApiKeyPermission).min(1).max(8),
    expires_at: z.iso.datetime({ offset: true }).nullable().optional(),
});
/** The token is returned once, at creation; only its SHA-256 is stored. */
export const ApiKeyCreated = ApiKey.extend({ token: z.string() });
/** POST /api/ext/v1/telemetry — measurements of an external sensor (any manufacturer, generic metric keys). */
export const ExternalTelemetry = z.object({
    device: z.object({
        external_id: z
            .string()
            .trim()
            .min(1)
            .max(64)
            .regex(/^[A-Za-z0-9_.:-]+$/),
        name: z.string().trim().min(1).max(120).optional(),
        device_type: z.enum(['sensor', 'controller', 'camera', 'other']).optional(),
        lat: z.number().min(-90).max(90).optional(),
        lon: z.number().min(-180).max(180).optional(),
    }),
    observed_at: z.iso.datetime({ offset: true }).optional(),
    metrics: z
        .record(z.string().regex(/^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+$/), z.number().finite())
        .refine((m) => Object.keys(m).length > 0 && Object.keys(m).length <= 64),
});
export const ExternalTelemetryResult = z.object({
    device_id: z.uuid(),
    created: z.boolean(),
    accepted: z.array(z.string()),
    rejected: z.array(z.string()),
});
/** GET /api/v1/metrics/catalog — metric keys and units (sensor integration, heat map layer). */
export const MetricCatalog = z.object({
    items: z.array(z.object({
        id: z.number().int(),
        key: z.string(),
        unit: z.string().nullable(),
        value_type: z.string(),
        name_en: z.string(),
    })),
});
//# sourceMappingURL=integrations.js.map